import type { SymbolKey } from './types';

type SymbolKeyLike =
  | Partial<Pick<SymbolKey, 'Code' | 'PeriodType' | 'Period' | 'TimeRef'>>
  | null
  | undefined;

export function normalizeSymbolKey(key: SymbolKeyLike): SymbolKey {
  return {
    Code: key?.Code ?? '',
    PeriodType: key?.PeriodType ?? '',
    Period: key?.Period ?? '',
    TimeRef: key?.TimeRef ?? ''
  };
}
